import {
  FilePdf, FileImage, FileDoc, FileXls, FilePpt, File as FileGeneric,
} from '@phosphor-icons/react/dist/ssr';

/** Passendes Phosphor-Icon je MIME-Typ einer Datei. */
export function materialIcon(mime: string | null | undefined) {
  if (!mime) return FileGeneric;
  if (mime === 'application/pdf') return FilePdf;
  if (mime.startsWith('image/')) return FileImage;
  if (mime.includes('word')) return FileDoc;
  if (mime.includes('sheet') || mime.includes('excel')) return FileXls;
  if (mime.includes('presentation') || mime.includes('powerpoint')) return FilePpt;
  return FileGeneric;
}

/** Menschlich lesbare Dateigrösse; '' wenn unbekannt/0. */
export function formatBytes(n: number | null | undefined): string {
  if (!n || n <= 0) return '';
  if (n < 1024) return `${n} B`;
  if (n < 1024 * 1024) return `${Math.round(n / 1024)} KB`;
  return `${(n / (1024 * 1024)).toFixed(1)} MB`;
}
